<template>
  <div class="hMenu">
      <v-app-bar color="#dd2129" dark fixed  height="76px">
        <v-container class="d-flex align-center">
          <v-app-bar-nav-icon class="hidden-md-and-up">
            <v-btn @click.stop="sideBar = !sideBar" icon>
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </v-app-bar-nav-icon>

          <img src="../assets/logo.png" height="50px" class="mr-5" alt="logo" />

          <div class="hidden-sm-and-down">
            <v-btn text v-for="(menu,index) in menus" :key="index" :to="menu.route">
              <v-icon class="mr-3">{{menu.icon}}</v-icon>
              <div class="btntpb">{{menu.nome}}</div>
            </v-btn>
          </div>

          <v-spacer></v-spacer>

          <v-menu open-on-hover bottom offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn class="px-1" dark outlined v-on="on">
                <span>{{$store.getters.language}}</span>
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                v-for="(idioma,index) in this.$store.getters.idiomas"
                :key="index"
                @click="changeLanguage(idioma.idioma,true)"
              >
                <v-list-item-title class="text-uppercase">{{idioma.idioma}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-container>
      </v-app-bar>

    <v-app>
      <v-navigation-drawer v-model="sideBar" temporary app dark color="#dd2129">
        <v-list>
          <v-list-item v-for="(menu,index) in menus" :key="index" :to="menu.route">
            <v-list-item-icon>
              <v-icon class="mr-8">{{ menu.icon }}</v-icon>
              <v-list-item-title>{{ menu.nome }}</v-list-item-title>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app>
  </div>
</template>

<script>
import { getLangValue, haveLanguage } from "@/globalFunctions.js";
export default {
  name: "ComponentNavBar",
  methods: {
    putMenuNomes: async function() {
      var menuHome = await getLangValue(
        "Menu",
        "Home",
        this.$store.getters.language
      );
      var menuNoticias = await getLangValue(
        "Menu",
        "Noticias",
        this.$store.getters.language
      );
      var menuRoteiros = await getLangValue(
        "Menu",
        "Roteiros",
        this.$store.getters.language
      );
      var menuEventos = await getLangValue(
        "Menu",
        "Eventos",
        this.$store.getters.language
      );

      var menuContacts = await getLangValue(
        "Menu",
        "Contactos",
        this.$store.getters.language
      );

      this.menus.push({ nome: menuHome, icon: "mdi-home", route: "/" });
      this.menus.push({
        nome: menuNoticias,
        icon: "mdi-newspaper",
        route: "/" + this.$store.getters.language + "/noticias"
      });
      this.menus.push({
        nome: menuRoteiros,
        icon: "mdi-map",
        route: "/" + this.$store.getters.language + "/roteiros"
      });
      this.menus.push({
        nome: menuEventos,
        icon: "mdi-calendar-text",
        route: "/" + this.$store.getters.language + "/eventos"
      });
      this.menus.push({
        nome: menuContacts,
        icon: "mdi-contacts",
        route: "/" + this.$store.getters.language + "/contactos"
      });
    },
    changeLanguage: async function(lang, reload) {
      var hvLanguage = await haveLanguage(lang);

      if (hvLanguage) {
        await this.$store.dispatch("setLanguage", lang);
      } else {
        await this.$store.dispatch("setLanguage", this.$store.getters.language);
      }

      var fullPath = this.$route.fullPath;

      if (fullPath != "/") {
        fullPath = fullPath.substring(fullPath.indexOf("/", 1) + 1);
        this.$router.replace(
          "/" + this.$store.getters.language + "/" + fullPath
        );
      }

      this.menus = [];
      await this.putMenuNomes();

      if (reload) {
        this.$router.go(0);
      }
    }
  },
  async mounted() {
    await this.changeLanguage(this.$route.params.lang, false);
  },
  data: () => ({
    sideBar: null,
    menus: [],
    linguagens: [{ nome: "", sigla: "" }]
  })
};
</script>

<style lang="scss">
.hMenu {
  height: 76px;
}
.menuOver {
  z-index: 1;
}
.btntpb {
  margin-bottom: -2px;
}
</style>